import React, { useEffect, useRef, useState } from "react";

const Radar = ({ size = 150 }) => {
  const [blips, setBlips] = useState([]);
  const sweepAngle = useRef(0);

  // Generate 1 random blip per minute
  useEffect(() => {
    const generateBlip = () => {
      const angle = Math.random() * 360;
      const radius = Math.random() * (size / 2 - 10);
      setBlips([{ id: Date.now(), angle, radius }]);
    };

    generateBlip(); // initial blip
    const interval = setInterval(generateBlip, 60000); // every 60 sec
    return () => clearInterval(interval);
  }, [size]);

  // Animate sweep and reveal blips only when sweep is near them
  useEffect(() => {
    const step = 2; // degrees per frame
    const interval = setInterval(() => {
      sweepAngle.current = (sweepAngle.current + step) % 360;
      setBlips((prev) =>
        prev.map((b) => {
          const diff = Math.abs(b.angle - sweepAngle.current);
          return { ...b, visible: diff < 5 || diff > 355 };
        })
      );
    }, 30);
    return () => clearInterval(interval);
  }, []);

  // Convert polar to cartesian
  const polarToCartesian = (angle, radius) => {
    const rad = (angle * Math.PI) / 180;
    return {
      x: size / 2 + radius * Math.cos(rad),
      y: size / 2 + radius * Math.sin(rad),
    };
  };

  return (
    <div
      style={{
        width: size,
        height: size,
        borderRadius: "50%",
        border: "1px solid rgba(255, 255, 255, 1)",
        position: "relative",
        overflow: "hidden",
        background: "#00000008",
      }}
    >
      {/* Radar sweep */}
      <div
        style={{
          position: "absolute",
          width: "100%",
          height: "100%",
          top: 0,
          left: 0,
          borderRadius: "50%",
          background: "conic-gradient(rgba(255, 255, 255, 0.66) 0deg, rgba(0,255,0,0) 60deg)",
          transform: `rotate(${sweepAngle.current}deg)`,
          transformOrigin: "50% 50%",
        }}
      ></div>

      {/* Blips */}
      {blips.map(
        (blip) =>
          blip.visible && (
            <div
              key={blip.id}
              style={{
                position: "absolute",
                width: 6,
                height: 6,
                borderRadius: "50%",
                background: "rgba(255, 255, 255, 1)",
                boxShadow: "0 0 8px rgba(255, 255, 255, 1)",
                ...polarToCartesian(blip.angle, blip.radius),
                transform: "translate(-3px, -3px)",
              }}
            />
          )
      )}
    </div>
  );
};

export default Radar;
